import { useEffect } from 'react';

export const ChatbotScript = () => {
    useEffect(() => {
        const scriptUrl = `${process.env.REACT_APP_URL_LOCAL}/chat-web-widget.js`;

        if (!document.querySelector(`script[src="${scriptUrl}"]`)) {
            const script = document.createElement('script');
            script.src = scriptUrl;
            script.async = true;
            document.body.appendChild(script);
        }
    }, []);

    return null;
};
